import { ModuleType, TranslatableContent } from "@max/common";
import useUserIdToken from "hooks/useUserIdToken";
import LogRocket from "logrocket";
import toast from "react-hot-toast";

export interface PromptRequestOptions {
  threaded?: boolean;
  templateId?: string;
  threadId?: string;
  assistantId?: string;
  values?: any;
  prompt?: string;
}

export type QuestionResponse = {
  id: string;
  label: TranslatableContent;
  options?: TranslatableContent[];
  type: Extract<
    ModuleType,
    | "TextQuestion"
    | "SingleSelectQuestion"
    | "MultipleSelectQuestion"
    | "ImageQuestion"
    | "RankedQuestion"
    | "text"
    | "image"
  >;
};

export interface PromptResponse {
  fields?: { [key: string]: { content: TranslatableContent } };
  questions?: QuestionResponse[];
}

export interface PromptResult {
  response: PromptResponse;
  assistantId?: string;
  threadId?: string;
  messageId?: string;
}

export const usePrompt = () => {
  const accessToken = useUserIdToken();

  const request = async (
    options: PromptRequestOptions,
  ): Promise<PromptResponse> => {
    try {
      const response = await fetch(process.env.REACT_APP_AI_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(options),
      });
      const json = await response.json();
      return json?.response || {};
    } catch (error) {
      console.error(error);
      toast.error(
        "We encountered an issue while generating your content. You can continue or go back and try again.",
        { duration: 15000 },
      );
      LogRocket.captureException(error, {
        tags: {
          action: "template-generate",
        },
        extra: {
          promptId: options.templateId,
        },
      });
    }
  };

  return { request };
};
